import { Redirect } from 'expo-router';
import useRootStore from '@/stores/useRootStore';

export default function IndexRoute() {
  const tab = useRootStore((state) => state.activeTab);
  const activeContextPathname = useRootStore(
    (state) => state.activeContextPathname,
  );
  const organizationId = useRootStore((state) => state.organizationId);
  const teamId = useRootStore((state) => state.teamId);

  if (tab === 'organization' && activeContextPathname === '/organization') {
    return (
      <Redirect
        href={
          organizationId
            ? { pathname: '/organization', params: { organizationId } }
            : '/organization'
        }
      />
    );
  }

  if (tab === 'team' && activeContextPathname === '/team') {
    return (
      <Redirect
        href={teamId ? { pathname: '/team', params: { teamId } } : '/team'}
      />
    );
  }

  if (tab) {
    return <Redirect href={`/${tab}`} />;
  }

  return <Redirect href="/event" />;
}
